import { BreakpointProps } from '@/app/features/common/common.types';
import styled from '@emotion/styled';
import { isTablet, Link, rem } from '@triumph/design-system';

export const DocumentCardTitle = styled.div`
    display: flex;
    flex-direction: row;
    gap: ${rem(8)};
    align-items: center;
    color: black;
`;

export const DocumentCardHeader = styled.div`
    display: flex;
    flex-direction: row;
    gap: ${rem(8)};
    align-items: center;
    justify-content: space-between;
`;

export const DocumentPreviews = styled.div<BreakpointProps>`
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: ${rem(8)};
    flex-direction: ${({ breakpoint }) =>
        isTablet(breakpoint) ? 'row' : 'column'};
    padding: 0 ${({ breakpoint }) => (isTablet(breakpoint) ? rem(20) : 0)};
`;

export const DownloadAllLink = styled(Link)`
    text-decoration: underline;
    font-size: ${rem(14)};
    cursor: pointer;
`;
